"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Recipient = /*#__PURE__*/function () {
  function Recipient(opt) {
    _classCallCheck(this, Recipient);

    if (opt) {
      this.fillObject(opt);
    }
  }

  _createClass(Recipient, [{
    key: "fillObject",
    value: function fillObject(opt) {
      if (opt.email) {
        this.email = opt.email;
      } else if (opt.userId) {
        this.userId = opt.userId;
      } else {
        this.role = opt.role;
        this.to = opt.to;
      }
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'recipient.schema.json',
        type: 'object',
        additionalProperties: true,
        properties: {
          anyOf: [{
            email: {
              type: ['string', 'null']
            }
          }, {
            userId: {
              type: ['string', 'null']
            }
          }, {
            role: {
              type: ['string', 'null']
            }
          }, {
            to: {
              type: ['string', 'null']
            }
          }]
        }
      };
    }
  }]);

  return Recipient;
}();

module.exports = Recipient;